import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { currentLang } from "@/i18n";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      if (data.language !== currentLang()) {
        api.patch("/auth/me", { language: currentLang() }).catch(() => {});
        data.language = currentLang();
      }
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- api/currentLang are module-level
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => api.post("/auth/refresh").catch(() => {}), 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const setCredits = (credits) => setUser((u) => (u ? { ...u, credits } : u));

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, logout, setCredits }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
